import React, { useState, useEffect } from 'react';
import { LandingWrapper, LandingContainer, LandingHead, LandingDesc, LandingButton } from "./style";


const descriptions = [
  "Stellar Art, the forefront of the AI-driven creative revolution. We're transforming the way you conceive and generate art.",
];

const LandingSection = () => {
  const [currentDescription, setCurrentDescription] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDescription((currentDescription + 0) % descriptions.length);
    }, 7000);
    // This function runs when the component unmounts or when the effect dependencies change
    return () => clearInterval(timer);
  }, [currentDescription]);

  return (
    <LandingWrapper>
      <LandingContainer>
        <LandingHead data-aos="fade-up">Unleash Creativity. 
          <br></br>Spark Joy.
          <br></br>Enter the Stellar Art Universe!
          </LandingHead>
        <LandingDesc data-aos="fade-up" data-aos-delay="300">
          {descriptions[currentDescription]}
        </LandingDesc>
        <LandingButton data-aos="fade-up" data-aos-delay="600">
      <a href="https://app.stellartai.com/" target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none', color: 'inherit'}}>GET STARTED</a>
    </LandingButton>
      </LandingContainer>
    </LandingWrapper>
  );
};

export default LandingSection;
